import React, {Component} from 'react';
import {MDBCard} from 'mdbreact';

class about extends Component {
  render() {
    return (
      // {/* <MDBCard className='my-5 px-5 pb-5 under' /> */}
      <MDBCard className='my-5 px-5 pb-5 over'>
        <h1 className='aboutPage'>About page</h1>
        <p className='aboutPageP'>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur,
          cum quos officia vel modi, doloremque mollitia reprehenderit
          exercitationem saepe, qui in quis eaque. Unde atque expedita velit
          dolores cum doloremque consectetur necessitatibus! Cupiditate
          consequuntur iste quis, nostrum voluptate dicta suscipit incidunt
          ratione hic nemo, rem eligendi delectus molestias, excepturi
          repellendus reprehenderit laborum perspiciatis ad vel id placeat.
          Magnam, laboriosam nobis. Itaque totam quibusdam numquam rem placeat
          atque officia quasi vero cupiditate debitis temporibus, aliquam, ut
          animi repellendus perspiciatis error aut vel iste esse repudiandae?
          Debitis reprehenderit consectetur architecto earum in facere error
          laboriosam molestias ipsam magni, fugiat iusto odio illum cumque
          eligendi veniam magnam recusandae itaque quas vel accusamus quia ipsa
          iure voluptatum? Dicta, quis ipsum sint, adipisci quod aperiam
          consequuntur at sequi inventore recusandae vel exercitationem officia
          repellat accusantium enim ullam consectetur ratione natus! Minima
          iusto delectus odit amet exercitationem impedit fugiat alias totam
          suscipit magnam fuga debitis sapiente, doloribus facilis est iure a
          aut corrupti odio reiciendis eum non ipsam? Tempora perspiciatis
          necessitatibus magnam, eligendi aliquam earum. Cumque impedit nostrum
          sed, ad atque maiores minus magni eveniet saepe rem ipsa, sapiente
          laboriosam placeat labore ratione
        </p>
      </MDBCard>
    );
  }
}

export default about;
